export class TipoBienesCodigos {
    static vehiculos = 'VEH';
    static maquinarias = 'MAQ';
    static inmuebles = 'INM';
    static otros = 'OTR';
}